export default __webpack_public_path__ + "static/media/dc-vector-art.40930c8c.webp";